import repository from '@/utils/repository';

const resource = '/move/MNG_SalesReport002';

export default {
    getData: (data) => {
        return repository.post(`${resource}/getData`, {
            ...data
        });
    },
    storeSave: (data) => {
        return repository.post(`${resource}/storeSave`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    uploadFileToSharePath: (data) => {
        return repository.post('/move/uploadFileToSharePath', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getImage: (path, companyCd, status) => {
        let parts = path == null ? [''] : path.split(/[\\]+/);
        let fileName = parts[parts.length - 1];
        return repository.get(`move/preview-image-sys004/${companyCd}/${status}/${fileName}`, {
            responseType: 'blob'
        });
    }
};
